import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface ILinkedLawsuitTypeProperties {
  proc_vinc_tipo_id: number | null;
  proc_vinc_tipo_descricao: string;
}

const LinkedLawsuitType: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyLinkedLawsuitType = {
    proc_vinc_tipo_id: null,
    proc_vinc_tipo_descricao: '',
  };

  const [linkedLawsuitTypes, setLinkedLawsuitTypes] = useState<ILinkedLawsuitTypeProperties[]>([]);
  const [linkedLawsuitType, setLinkedLawsuitType] = useState(emptyLinkedLawsuitType);
  const [deleteLinkedLawsuitType, setLinkedLawsuitTypeDialog] = useState(false);
  const [deleteLinkedLawsuitTypesDialog, setLinkedLawsuitTypesDialog] = useState(false);
  const [
    selectedLinkedLawsuitTypes, setSelectedLinkedLawsuitTypes,
  ] = useState<ILinkedLawsuitTypeProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/lawsuits/linkedlawsuitstypes/show/all');
      setLinkedLawsuitTypes(response.data);
    })();
  }, []);

  const columns = [
    { field: 'proc_vinc_tipo_id', header: 'Código', sortable: true },
    { field: 'proc_vinc_tipo_descricao', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/linkedlawsuittype/create');
  };

  const hidedeleteLinkedLawsuitType = () => {
    setLinkedLawsuitTypeDialog(false);
  };

  const hidedeleteLinkedLawsuitTypesDialog = () => {
    setLinkedLawsuitTypesDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editLinkedLawsuitType = (rowData:any) => {
    history.push(`/lawsuit/linkedlawsuittype/edit/${rowData.proc_vinc_tipo_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteLinkedLawsuitType = (linkedLawsuitType: React.SetStateAction<{
    proc_vinc_tipo_id: null; proc_vinc_tipo_descricao: string;
  }>) => {
    setLinkedLawsuitType(linkedLawsuitType);
    setLinkedLawsuitTypeDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/linkedlawsuitstypes/delete/${linkedLawsuitType.proc_vinc_tipo_id}`);

    setLinkedLawsuitTypeDialog(false);

    const updatedRecords = linkedLawsuitTypes
      .filter((val) => val.proc_vinc_tipo_id !== linkedLawsuitType.proc_vinc_tipo_id);
    setLinkedLawsuitTypes(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editLinkedLawsuitType(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteLinkedLawsuitType(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteLinkedLawsuitTypeFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteLinkedLawsuitType} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteLinkedLawsuitTypesDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteLinkedLawsuitTypesDialog} />
      {/* <Button label="Sim" icon="pi pi-check" className="p-button-text"
      onClick={deleteselectedLinkedLawsuitTypes} /> */}
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Tipos de processos vinculados</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-linkedLawsuitTypes table"
            id="table-linkedLawsuitTypes"
            ref={dt}
            value={linkedLawsuitTypes}
            editMode="row"
            dataKey="proc_vinc_tipo_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedLinkedLawsuitTypes}
            onSelectionChange={(e) => {
              const selLinkedLawsuitTypes = e.value as ILinkedLawsuitTypeProperties[];
              setSelectedLinkedLawsuitTypes(selLinkedLawsuitTypes);
            }}
            onRowDoubleClick={(e) => editLinkedLawsuitType(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteLinkedLawsuitType} style={{ width: '450px' }} header="Confirmação" modal footer={deleteLinkedLawsuitTypeFooter} onHide={hidedeleteLinkedLawsuitType}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {linkedLawsuitType && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{linkedLawsuitType.proc_vinc_tipo_descricao}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteLinkedLawsuitTypesDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteLinkedLawsuitTypesDialogFooter} onHide={hidedeleteLinkedLawsuitTypesDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {linkedLawsuitType
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default LinkedLawsuitType;
